import { RoutesMain as Routes } from "./routes";

export const App = () => <Routes />;
